import * as types from './_actionTypes';

// Fetch SME Courses
export const fetchSMECoursesRequest = () => ({
  type: types.FETCH_SME_COURSES_REQUEST
});

export const fetchSMECoursesSuccess = (courses) => ({
  type: types.FETCH_SME_COURSES_SUCCESS,
  payload: courses
});

export const fetchSMECoursesFailure = (error) => ({
  type: types.FETCH_SME_COURSES_FAILURE,
  payload: error
});

// Fetch Course Contents
export const fetchSMECourseContentsRequest = (courseId, filters = {}) => ({
  type: types.FETCH_SME_COURSE_CONTENTS_REQUEST,
  payload: { courseId, filters }
});

export const fetchSMECourseContentsSuccess = (contents) => ({
  type: types.FETCH_SME_COURSE_CONTENTS_SUCCESS,
  payload: contents
});

export const fetchSMECourseContentsFailure = (error) => ({
  type: types.FETCH_SME_COURSE_CONTENTS_FAILURE,
  payload: error
});

// Create Content
export const createSMEContentRequest = (courseId, contentData) => ({
  type: types.CREATE_SME_CONTENT_REQUEST,
  payload: { courseId, contentData }
});

export const createSMEContentSuccess = (content) => ({
  type: types.CREATE_SME_CONTENT_SUCCESS,
  payload: content
});

export const createSMEContentFailure = (error) => ({
  type: types.CREATE_SME_CONTENT_FAILURE,
  payload: error
});

// Update Content
export const updateSMEContentRequest = (contentId, contentData) => ({
  type: types.UPDATE_SME_CONTENT_REQUEST,
  payload: { contentId, contentData }
});

export const updateSMEContentSuccess = (content) => ({
  type: types.UPDATE_SME_CONTENT_SUCCESS,
  payload: content
});

export const updateSMEContentFailure = (error) => ({
  type: types.UPDATE_SME_CONTENT_FAILURE,
  payload: error
});

// Delete Content
export const deleteSMEContentRequest = (contentId) => ({
  type: types.DELETE_SME_CONTENT_REQUEST,
  payload: contentId
});

export const deleteSMEContentSuccess = (contentId) => ({
  type: types.DELETE_SME_CONTENT_SUCCESS,
  payload: contentId
});

export const deleteSMEContentFailure = (error) => ({
  type: types.DELETE_SME_CONTENT_FAILURE,
  payload: error
});

// Fetch Statistics
export const fetchSMEContentStatsRequest = (courseId) => ({
  type: types.FETCH_SME_CONTENT_STATS_REQUEST,
  payload: courseId
});

export const fetchSMEContentStatsSuccess = (stats) => ({
  type: types.FETCH_SME_CONTENT_STATS_SUCCESS,
  payload: stats
});

export const fetchSMEContentStatsFailure = (error) => ({
  type: types.FETCH_SME_CONTENT_STATS_FAILURE,
  payload: error
});

// Fetch Single Content by ID
export const fetchSMEContentByIdRequest = (contentId) => ({
  type: types.FETCH_SME_CONTENT_BY_ID_REQUEST,
  payload: contentId
});

export const fetchSMEContentByIdSuccess = (content) => ({
  type: types.FETCH_SME_CONTENT_BY_ID_SUCCESS,
  payload: content
});

export const fetchSMEContentByIdFailure = (error) => ({
  type: types.FETCH_SME_CONTENT_BY_ID_FAILURE,
  payload: error
});

// Clear Error
export const clearSMEContentError = () => ({
  type: types.CLEAR_SME_CONTENT_ERROR
});
